import type { ReactNode } from 'react';
import { classNames } from '~/utils/classNames';

export interface TabItem<T extends string = string> {
  value: T;
  label: ReactNode;
}

export interface TabsProps<T extends string = string> {
  items: TabItem<T>[];
  selectedTab: T;
  onTabChange: (value: T) => void;
  shape?: 'rect' | 'pill';
}

export const Tabs = <T extends string = string>({ items, selectedTab, onTabChange, shape = 'pill' }: TabsProps<T>) => {
  return (
    <div
      className={classNames(
        'flex items-center p-1 shrink-0 border border-bolt-ds-borderOutline w-max',
        shape === 'pill' ? 'rounded-full' : 'rounded-lg',
      )}
    >
      {items.map((item) => (
        <button
          key={item.value}
          onClick={() => onTabChange(item.value)}
          className={classNames(
            'h-7',
            'flex items-center justify-center px-3 shrink-0',
            'transition-colors outline-none',
            'focus-visible:outline-2 focus-visible:outline-bolt-ds-brandHighlight',
            selectedTab === item.value
              ? 'bg-bolt-ds-brandContainer text-bolt-ds-brand'
              : 'bg-transparent text-bolt-ds-textSecondary',
            shape === 'pill' ? 'rounded-full' : 'rounded-md',
          )}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
};
